import { render, staticRenderFns } from "./serviceComment.vue?vue&type=template&id=2531580a&scoped=true"
import script from "./serviceComment.vue?vue&type=script&lang=js"
export * from "./serviceComment.vue?vue&type=script&lang=js"
import style0 from "./serviceComment.vue?vue&type=style&index=0&id=2531580a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531580a",
  null
  
)

export default component.exports